import { ThemeProvider as MuiThemeProvider } from '@mui/material'
import { ReactNode } from 'react'
import { theme } from './theme/theme'

export const ThemeProvider = ({ children }: { children: ReactNode }) => (
  <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
)
